import React from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Badge } from '@/components/shadcn/ui/badge';
import { Currency } from '@/constants';
import useChainByCurrency from '@/hooks/useChainByCurrency';
import useExplorerByCurrency from '@/hooks/useExplorerByCurrency';
import { truncateMidAddressInputValue } from '@/utils';

const BuildDetailsL1ContractExplorerLink: React.FC<{
  id: string;
  currency: Currency;
}> = ({ currency, id }) => {
  const explorerLink = useExplorerByCurrency(currency);

  const { isEvm, isTron, chainData } = useChainByCurrency(currency);

  if (!id) {
    return null;
  }

  if (explorerLink) {
    const href = isEvm ? `${explorerLink}/address/${id}` : isTron ? `${explorerLink}/#/contract/${id}` : '';

    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Badge className="cursor-pointer gap-1">
          <ChainIcon src={(chainData?.custom?.icon as string) || ''} className="size-3 p-0" />
          {truncateMidAddressInputValue(id)}
        </Badge>
      </a>
    );
  }

  return null;
};

export default BuildDetailsL1ContractExplorerLink;
